import React, { useState, useEffect, useContext, useRef } from "react";
import "./familyDetails.css";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import successImg from "../../assets/images/successImg.png";
import { useFormik } from "formik";
import { object, string } from "yup";
import translations from "./translation.json";
import { LanguageContext } from "../../Components/LanguageContext";
import { useDispatch } from "react-redux";
import { setFamilyDetails } from "../../appRedux/store";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper", //box color
  border: "1px solid white", //box border
  boxShadow: 24,
  pt: 2,
  px: 0,
  pb: 3,
};

const FamilySchema = object({
  total_brothers: string().required("this feild is required"),
  total_sisters: string().required("this feild is required"),
  married_brothers: string().required("this feild is required"),
  married_sisters: string().required("this feild is required"),
});

export function FamilyDetails() {
  const { language } = useContext(LanguageContext);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const total_brothersRef = useRef(null);
  const total_sistersRef = useRef(null);
  const married_brothersRef = useRef(null);
  const married_sistersRef = useRef(null);

  const formik = useFormik({
    initialValues: {
      father_name: "",
      father_occupation: "",
      mother_name: "",
      mother_occupation: "",
      total_brothers: "",
      total_sisters: "",
      married_brothers: "",
      married_sisters: "",
    },
    validationSchema: FamilySchema,
    onSubmit: async (values) => {
      const fieldRefs = {
        total_brothers: total_brothersRef,
        total_sisters: total_sistersRef,
        married_brothers: married_brothersRef,
        married_sisters: married_sistersRef,
      };

      Object.keys(formik.errors).some((field) => {
        const ref = fieldRefs[field];
        if (ref?.current) {
          ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
          ref.current.focus();
          return true; // stop after first error
        }
        return false;
      });

      try {
        const dataToSave = {
          ...values,
          total_brothers: Number(values.total_brothers) || 0,
          total_sisters: Number(values.total_sisters) || 0,
          married_brothers: Number(values.married_brothers) || 0,
          married_sisters: Number(values.married_sisters) || 0,
        };

        localStorage.setItem("familyDetails", JSON.stringify(dataToSave));

        handleOpen();
      } catch (error) {
        console.error("Error saving to localStorage:", error);
      }
    },
   
     
  });
  // get and set form data from localStorage to fields
useEffect(() => {
const familyDetails = localStorage.getItem("familyDetails");
if (familyDetails) {
  try {
    const parsedData = JSON.parse(familyDetails);
    formik.setValues(parsedData);
  } catch (err) {
    console.error("Error parsing saved data:", err);
  }
}

}, []);


  return (
    <form onSubmit={formik.handleSubmit}>
      <div>
        {/* row1 */}
        <div className="family-subcontainer">
          <div>
            <div className="family-label">
              {translations[language].father_name}
            </div>
            <div className="family-input">
              <input
                type="text"
                placeholder="Enter Father Name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                id="father_name"
                  name="father_name"
                  value={formik.values.father_name}
              />
            </div>
          </div>
          <div>
            <div className="family-label">
              {translations[language].father_occupation}
            </div>
            <div className="family-input">
              <input
                type="text"
                placeholder="Enter Father's Occupation"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                id="father_occupation"
                  name="father_occupation"
                  value={formik.values.father_occupation}
              />
            </div>
          </div>
        </div>
        {/* row2 */}
        <div className="family-subcontainer">
          <div>
            <div className="family-label">
              {translations[language].mother_name}
            </div>
            <div className="family-input">
              <input
                type="text"
                placeholder="Enter Mother Name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                id="mother_name"
                 name="mother_name"
                 value={formik.values.mother_name}
              />
            </div>
          </div>
          <div>
            <div className="family-label">
              {translations[language].mother_occupation}
            </div>
            <div className="family-input">
              <input
                type="text"
                placeholder="Enter Mother's Occupation"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                id="mother_occupation"
                name="mother_occupation"
                value={formik.values.mother_occupation}
              />
            </div>
          </div>
        </div>
        {/* row3 */}
        <div className="family-subcontainer">
          <div>
            <div className="family-label">
              {translations[language].no_of_brothers}
              <span className="text-danger">*</span>
            </div>
            <div className="family-input">
              {/* <input
                type="text"
                placeholder="Enter No. of Brothers"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                id="total_brothers"
                  name="total_brothers"
                  value={formik.values.total_brothers}
                className={
                  formik.touched.total_brothers && formik.errors.total_brothers
                    ? "error"
                    : ""
                }
              /> */}
              <select
                  
                  name="total_brothers"
                  id="total_brothers"
                  value={formik.values.total_brothers}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={`dropdown-btnBasic ${
                    formik.touched.total_brothers && formik.errors.total_brothers ? "error" : ""
                  }`}
                >
                               <option value="" disabled>Select</option>
  <option value="0">0</option>
  <option value="1">1</option>
  <option value="2">2</option>
  <option value="3">3</option>
  <option value="4">4</option>
  <option value="5">5</option>
  <option value="6">6</option>
  <option value="7">7</option>
  <option value="8">8</option>
  <option value="9">9</option>
  <option value="10">10</option>

                </select>
              <div>
                {formik.touched.total_brothers &&
                  formik.errors.total_brothers && (
                    <div className="text-danger">
                      {formik.errors.total_brothers}
                    </div>
                  )}
              </div>
            </div>
          </div>
          <div>
            <div className="family-label">
              {translations[language].no_of_sisters}
              <span className="text-danger">*</span>
            </div>
            <div className="family-input">
              {/* <input
                type="text"
                placeholder="Enter No. of Sisters"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                id="total_sisters"
                name="total_sisters"
                value={formik.values.total_sisters}
                className={
                  formik.touched.total_sisters && formik.errors.total_sisters
                    ? "error"
                    : ""
                }
              /> */}
              <select
                  
                  name="total_sisters"
                  id="total_sisters"
                  value={formik.values.total_sisters}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={`dropdown-btnBasic ${
                    formik.touched.total_sisters && formik.errors.total_sisters? "error" : ""
                  }`}
                >
                               <option value="" disabled>Select</option>
  <option value="0">0</option>
  <option value="1">1</option>
  <option value="2">2</option>
  <option value="3">3</option>
  <option value="4">4</option>
  <option value="5">5</option>
  <option value="6">6</option>
  <option value="7">7</option>
  <option value="8">8</option>
  <option value="9">9</option>
  <option value="10">10</option>

                </select>
              <div>
                {formik.touched.total_sisters &&
                  formik.errors.total_sisters && (
                    <div className="text-danger">
                      {formik.errors.total_sisters}
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
        {/* row4 */}
        <div className="family-subcontainer">
          <div>
            <div className="family-label">
              {translations[language].married_brothers}
              <span className="text-danger">*</span>
            </div>
            <div className="family-input">
              {/* <input
                type="text"
                placeholder="Enter Married Brothers"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                id="married_brothers"
                name="married_brothers"
                value={formik.values.married_brothers}
                className={
                  formik.touched.married_brothers &&
                  formik.errors.married_brothers
                    ? "error"
                    : ""
                }
              /> */}
              <select
                  
                  name="married_brothers"
                  id="married_brothers"
                  value={formik.values.married_brothers}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={`dropdown-btnBasic ${
                    formik.touched.married_brothers && formik.errors.married_brothers? "error" : ""
                  }`}
                >
                              <option value="" disabled>Select</option>
  <option value="0">0</option>
  <option value="1">1</option>
  <option value="2">2</option>
  <option value="3">3</option>
  <option value="4">4</option>
  <option value="5">5</option>
  <option value="6">6</option>
  <option value="7">7</option>
  <option value="8">8</option>
  <option value="9">9</option>
  <option value="10">10</option>

                </select>
              <div>
                {formik.touched.married_brothers &&
                  formik.errors.married_brothers && (
                    <div className="text-danger">
                      {formik.errors.married_brothers}
                    </div>
                  )}
              </div>
            </div>
          </div>
          <div>
            <div className="family-label">
              {translations[language].married_sisters}
              <span className="text-danger">*</span>
            </div>
            <div className="family-input">
              {/* <input
                type="text"
                placeholder="Enter Married Sisters"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                id="married_sisters"
                name="married_sisters"
                value={formik.values.married_sisters}
                className={
                  formik.touched.married_sisters &&
                  formik.errors.married_sisters
                    ? "error"
                    : ""
                }
              /> */}
                 <select
                  
                  name="married_sisters"
                  id="married_sisters"
                  value={formik.values.married_sisters}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={`dropdown-btnBasic ${
                    formik.touched.married_sisters && formik.errors.married_sisters? "error" : ""
                  }`}
                >
                               <option value="" disabled>Select</option>
  <option value="0">0</option>
  <option value="1">1</option>
  <option value="2">2</option>
  <option value="3">3</option>
  <option value="4">4</option>
  <option value="5">5</option>
  <option value="6">6</option>
  <option value="7">7</option>
  <option value="8">8</option>
  <option value="9">9</option>
  <option value="10">10</option>

                </select>
              <div>
                {formik.touched.married_sisters &&
                  formik.errors.married_sisters && (
                    <div className="text-danger">
                      {formik.errors.married_sisters}
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>

        {/* modal */}
        <div>
          <div className="btnBasicSave">
            <Button type="submit">{translations[language].btnSave}</Button>
          </div>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
          >
            <Fade in={open}>
              <Box sx={style} className="modal-box">
                <img srcSet={successImg} />
                <Typography
                  id="transition-modal-title"
                  variant="h6"
                  component="h2"
                >
                  Thank You
                </Typography>
                <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                  The profile has been successfully updated
                </Typography>
              </Box>
            </Fade>
          </Modal>
        </div>
      </div>
    </form>
  );
}
